import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { Slider, Box, Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { memo, useCallback } from 'react';

type Props = {
  value: number;
  onChange: (distributionStrategy: number) => void;
};

const MAX = 1;
const MIN = 0.1; // can't be 0 because of backend reasons
const marks = [
  {
    value: MIN,
    label: '',
  },
  {
    value: MAX,
    label: '',
  },
];

function DistributionStrategy({ value, onChange }: Props) {
  const { t } = useTranslation('interface');

  const handleChange = useCallback(
    (_: Event, newValue: number | number[]) => {
      onChange(Number(newValue));
    },
    [onChange],
  );

  const handleSetMin = useCallback(() => {
    onChange(MIN);
  }, [onChange]);

  const handleSetMax = useCallback(() => {
    onChange(MAX);
  }, [onChange]);

  return (
    <Stack sx={{ marginRight: '10px', overflow: 'visible' }}>
      <PropertiesLabel
        labelRatio={50}
        i18nkey='interface:simulation.experimental_settings.distribution_strategy.label'
      >
        <Slider
          marks={marks}
          step={0.1}
          value={value}
          valueLabelDisplay='off'
          min={MIN}
          max={MAX}
          onChange={handleChange}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography onClick={handleSetMin} sx={{ cursor: 'pointer' }}>
            {t('interface:simulation.experimental_settings.distribution_strategy.time')}
          </Typography>
          <Typography onClick={handleSetMax} sx={{ cursor: 'pointer' }}>
            {t('interface:simulation.experimental_settings.distribution_strategy.distance')}
          </Typography>
        </Box>
      </PropertiesLabel>
    </Stack>
  );
};

export default memo(DistributionStrategy)